import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

/**
 * Custom hook to fetch and cache body part options
 * @returns {Object} { bodyPartOptions, loading, error, refetch }
 */
export const useBodyParts = () => {
  const [bodyPartOptions, setBodyPartOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBodyParts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await makeGetCall('/body-parts');
      
      if (response?.data?.success) {
        setBodyPartOptions(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch body parts');
      }
    } catch (err) {
      console.error('Error fetching body parts:', err);
      setError(err.message || 'Failed to fetch body parts');
      
      // Fallback to hardcoded options if API fails (aligned with your data)
      setBodyPartOptions([
        { label: 'Chest', value: 'CHEST' },
        { label: 'Abdomen', value: 'ABDOMEN' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBodyParts();
  }, []);

  const refetch = () => {
    fetchBodyParts();
  };

  return {
    bodyPartOptions,
    loading,
    error,
    refetch
  };
};